import { render, staticRenderFns } from "./RefuseOnlySbrhvi.vue?vue&type=template&id=92ccca7e&scoped=true&"
import script from "./RefuseOnlySbrhvi.vue?vue&type=script&lang=js&"
export * from "./RefuseOnlySbrhvi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ccca7e",
  null
  
)

export default component.exports